import { createSelector } from "reselect";
import type { State } from "../../pages/AppStoreWrapper";
import type { LinkingInfo, Types, Algorithm } from "../../components/LinkingInfoForm/types/LinkingInfoForm.types";
import type { State as LinkingInfoState } from "../../reducers/linkingInfo";

export const getName = createSelector(
  (state: State): LinkingInfoState => state.linking,
  (linking: LinkingInfoState): string => linking.get("name")
);

export const getType = createSelector(
  (state: State): LinkingInfoState => state.linking,
  (linking: LinkingInfoState): Types => linking.get("type")
);

export const getTagsGeneration = createSelector(
  (state: State): LinkingInfoState => state.linking,
  (linking: LinkingInfoState): Array<string> => linking.get("tagsGeneration")
);

export const getTagsDisplay = createSelector(
  (state: State): LinkingInfoState => state.linking,
  (linking: LinkingInfoState): Array<string> => linking.get("tagsDisplay")
);

export const getTemplateCode = createSelector(
  (state: State): LinkingInfoState => state.linking,
  (linking: LinkingInfoState): string => linking.get("templateCode")
);

export const getSorting = createSelector(
  (state: State): LinkingInfoState => state.linking,
  (linking: LinkingInfoState): string => linking.get("sorting")
);

export const getHeight = createSelector(
  (state: State): LinkingInfoState => state.linking,
  (linking: LinkingInfoState): number => linking.get("height")
);

export const getWidth = createSelector(
  (state: State): number => state.linking.get("width"),
  (width: number): number => width
);

export const getLinkingInfo = createSelector(
  (state: State): LinkingInfoState => state.linking,
  (linking: LinkingInfoState): LinkingInfo => linking.toJS() as LinkingInfo
);

export const getAlgorithm = createSelector(
  (state: State): LinkingInfoState => state.linking,
  (li: LinkingInfoState): Algorithm => li.get("algorithm")
);

export const getLinkingInfoUsePagination = createSelector(
  (state: State): LinkingInfoState => state.linking,
  (li: LinkingInfoState): boolean => li.get("usePagination")
);
